export type ChartGranularity = 'day' | 'week' | 'month';

export function periodBucketLabel(granularity: ChartGranularity): string {
  switch (granularity) {
    case 'week':
      return 'semana';
    case 'month':
      return 'mes';
    default:
      return 'día';
  }
}

/** Trend RPCs agrupan por día calendario. */
export function inferTrendGranularity(_startDate?: string, _endDate?: string): ChartGranularity {
  return 'day';
}

export function cohortGranularityFromRange(
  startDate?: string,
  endDate?: string
): 'week' | 'month' {
  if (!startDate || !endDate) {
    return 'week';
  }
  const start = new Date(`${startDate}T12:00:00`);
  const end = new Date(`${endDate}T12:00:00`);
  const days = Math.ceil((end.getTime() - start.getTime()) / 86_400_000) + 1;
  return days > 60 ? 'month' : 'week';
}

const STATIC_CHART_SUBTITLES: Record<string, string> = {
  'cyd-by-reason': 'Unidades cambiadas o devueltas por motivo en el período',
  'cyd-distribution': 'Reparto de unidades entre cambios y devoluciones',
  'orders-by-status': 'Cantidad de órdenes por estado en el período',
  'orders-by-courier': 'Órdenes CyD con solicitud en el período, por método de envío',
  'orders-by-logistics': 'Órdenes CyD con solicitud en el período, por empresa logística',
  'cyd-requests-by-status': 'CyD abiertas en Boris por estado · sin filtro de período',
};

export function getPieChartValueLabel(metricId?: string): string {
  switch (metricId) {
    case 'orders-by-courier':
    case 'orders-by-logistics':
    case 'orders-by-status':
      return 'órdenes';
    case 'cyd-requests-by-status':
      return 'solicitudes';
    default:
      return 'unidades';
  }
}

export function getChartSubtitle(
  metricId: string,
  options?: {
    granularity?: ChartGranularity | 'week' | 'month';
    startDate?: string;
    endDate?: string;
  }
): string | undefined {
  if (metricId in STATIC_CHART_SUBTITLES) {
    return STATIC_CHART_SUBTITLES[metricId];
  }

  const granularity: ChartGranularity =
    options?.granularity === 'week' || options?.granularity === 'month'
      ? options.granularity
      : options?.granularity === 'day'
        ? 'day'
        : inferTrendGranularity(options?.startDate, options?.endDate);

  const bucket = periodBucketLabel(granularity);

  switch (metricId) {
    case 'cyd-trend':
      return `Unidades cambiadas o devueltas por ${bucket}`;
    case 'sales-trend':
      return `Monto vendido en pesos por ${bucket}`;
    case 'cyd-cohort-rate':
      return granularity === 'month'
        ? 'Tasa de cambios y devoluciones sobre ventas, por mes de venta'
        : 'Tasa de cambios y devoluciones sobre ventas, por semana de venta';
    default:
      return undefined;
  }
}
